import i18n, { DEFAULT_LOCALE } from '@/utils/i18n';
import {
  defaultDynamicConfigValues,
  getValueFromConfigs,
} from '@/contexts/dynamic-config-utils';
import { DynamicConfig } from '@/contexts/dynamic-config';
import { EmployeeRestaurant } from '@/contexts/user-context';
import {
  RefetchQueryType,
  useRegenerateSmartOrder,
} from './use-regenerate-smart-order';
import { SmartOrderParams } from '@/utils/smart-order';
import { useCallback } from 'react';
import { useToasts } from '@/contexts/toast-context';

interface Props {
  smartOrderParams: SmartOrderParams | null;
}

export const useSmartOrderRestaurant = ({ smartOrderParams }: Props) => {
  const { showErrorToast } = useToasts();

  const { regenerateSmartOrders, regenerateSmartOrdersLoading } =
    useRegenerateSmartOrder();

  const onSelectRestaurant = useCallback(
    async (
      restaurantRelationship: EmployeeRestaurant,
      supplierDynamicConfig: DynamicConfig,
      translationsEnabled: boolean,
    ) => {
      try {
        if (smartOrderParams) {
          const isSaltApiEnabled = getValueFromConfigs(
            'salt_api_integration_enabled',
            supplierDynamicConfig,
            restaurantRelationship.chatDynamicConfig,
            defaultDynamicConfigValues.salt_api_integration_enabled,
          );
          const isItemGroupsEnabled = getValueFromConfigs(
            'item_groups_enabled',
            supplierDynamicConfig,
            restaurantRelationship.chatDynamicConfig,
            defaultDynamicConfigValues.item_groups_enabled,
          );

          await regenerateSmartOrders(
            {
              employeeRestaurant: restaurantRelationship,
              locale: translationsEnabled ? i18n.locale : DEFAULT_LOCALE,
              skipGroupMemberships: !isItemGroupsEnabled,
              skipSaltApi: !isSaltApiEnabled,
              smartOrderUUIDs: [smartOrderParams.smartOrderUUID],
            },
            RefetchQueryType.OPERATOR,
          );
        }
      } catch (e) {
        showErrorToast();
      }
    },
    [smartOrderParams, regenerateSmartOrders, showErrorToast],
  );

  return {
    onSelectRestaurant,
    regenerateSmartOrdersLoading,
  };
};
